"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.ketonMessages = exports.urobilinogenMessages = exports.bilirubinMessages = exports.bloodMessages = exports.proteinMessages = exports.glucoseMessages = exports.Keton = exports.Urobilinogen = exports.Bilirubin = exports.Blood = exports.Protein = exports.Glucose = void 0;
const schema_1 = require("../../../../schema");
var Glucose;
(function (Glucose) {
    Glucose["ZERO"] = "ZERO";
    Glucose["ONE"] = "ONE";
    Glucose["TWO"] = "TWO";
    Glucose["THREE"] = "THREE";
    Glucose["FOUR"] = "FOUR";
})(Glucose || (exports.Glucose = Glucose = {}));
var Protein;
(function (Protein) {
    Protein["ZERO"] = "ZERO";
    Protein["ONE"] = "ONE";
    Protein["TWO"] = "TWO";
    Protein["THREE"] = "THREE";
    Protein["FOUR"] = "FOUR";
})(Protein || (exports.Protein = Protein = {}));
var Blood;
(function (Blood) {
    Blood["ZERO"] = "ZERO";
    Blood["ONE"] = "ONE";
    Blood["TWO"] = "TWO";
    Blood["THREE"] = "THREE";
    Blood["FOUR"] = "FOUR";
})(Blood || (exports.Blood = Blood = {}));
var Bilirubin;
(function (Bilirubin) {
    Bilirubin["ZERO"] = "ZERO";
    Bilirubin["ONE"] = "ONE";
    Bilirubin["TWO"] = "TWO";
    Bilirubin["THREE"] = "THREE";
    Bilirubin["FOUR"] = "FOUR";
})(Bilirubin || (exports.Bilirubin = Bilirubin = {}));
var Urobilinogen;
(function (Urobilinogen) {
    Urobilinogen["ZERO"] = "ZERO";
    Urobilinogen["ONE"] = "ONE";
    Urobilinogen["TWO"] = "TWO";
    Urobilinogen["THREE"] = "THREE";
    Urobilinogen["FOUR"] = "FOUR";
})(Urobilinogen || (exports.Urobilinogen = Urobilinogen = {}));
var Keton;
(function (Keton) {
    Keton["ZERO"] = "ZERO";
    Keton["ONE"] = "ONE";
    Keton["TWO"] = "TWO";
    Keton["THREE"] = "THREE";
    Keton["FOUR"] = "FOUR";
})(Keton || (exports.Keton = Keton = {}));
exports.glucoseMessages = {
    [Glucose.ZERO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.glucose.ZERO",
        defaultMessage: "0"
    },
    [Glucose.ONE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.glucose.ONE",
        defaultMessage: "+"
    },
    [Glucose.TWO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.glucose.TWO",
        defaultMessage: "++"
    },
    [Glucose.THREE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.glucose.THREE",
        defaultMessage: "+++"
    },
    [Glucose.FOUR]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.glucose.FOUR",
        defaultMessage: "++++"
    }
};
exports.proteinMessages = {
    [Protein.ZERO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.protein.ZERO",
        defaultMessage: "0"
    },
    [Protein.ONE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.protein.ONE",
        defaultMessage: "+"
    },
    [Protein.TWO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.protein.TWO",
        defaultMessage: "++"
    },
    [Protein.THREE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.protein.THREE",
        defaultMessage: "+++"
    },
    [Protein.FOUR]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.protein.FOUR",
        defaultMessage: "++++"
    }
};
exports.bloodMessages = {
    [Blood.ZERO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.blood.ZERO",
        defaultMessage: "0"
    },
    [Blood.ONE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.blood.ONE",
        defaultMessage: "+"
    },
    [Blood.TWO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.blood.TWO",
        defaultMessage: "++"
    },
    [Blood.THREE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.blood.THREE",
        defaultMessage: "+++"
    },
    [Blood.FOUR]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.blood.FOUR",
        defaultMessage: "++++"
    }
};
exports.bilirubinMessages = {
    [Bilirubin.ZERO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.bilirubin.ZERO",
        defaultMessage: "0"
    },
    [Bilirubin.ONE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.bilirubin.ONE",
        defaultMessage: "+"
    },
    [Bilirubin.TWO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.bilirubin.TWO",
        defaultMessage: "++"
    },
    [Bilirubin.THREE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.bilirubin.THREE",
        defaultMessage: "+++"
    },
    [Bilirubin.FOUR]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.bilirubin.FOUR",
        defaultMessage: "++++"
    }
};
exports.urobilinogenMessages = {
    [Urobilinogen.ZERO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.urobilinogen.ZERO",
        defaultMessage: "0"
    },
    [Urobilinogen.ONE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.urobilinogen.ONE",
        defaultMessage: "+"
    },
    [Urobilinogen.TWO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.urobilinogen.TWO",
        defaultMessage: "++"
    },
    [Urobilinogen.THREE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.urobilinogen.THREE",
        defaultMessage: "+++"
    },
    [Urobilinogen.FOUR]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.urobilinogen.FOUR",
        defaultMessage: "++++"
    }
};
exports.ketonMessages = {
    [Keton.ZERO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.keton.ZERO",
        defaultMessage: "0"
    },
    [Keton.ONE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.keton.ONE",
        defaultMessage: "+"
    },
    [Keton.TWO]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.keton.TWO",
        defaultMessage: "++"
    },
    [Keton.THREE]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.keton.THREE",
        defaultMessage: "+++"
    },
    [Keton.FOUR]: {
        id: "ktx.transplantationScreening.labProcedures.totalUrineAnalysis.keton.FOUR",
        defaultMessage: "++++"
    }
};
const pH = schema_1.Schema.number().precision(1).min(3).max(9);
const gravity = schema_1.Schema.number().integer().min(200).max(2000);
const glucose = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Glucose.ZERO),
    schema_1.Schema.singleChoiceItem(Glucose.ONE),
    schema_1.Schema.singleChoiceItem(Glucose.TWO),
    schema_1.Schema.singleChoiceItem(Glucose.THREE),
    schema_1.Schema.singleChoiceItem(Glucose.FOUR)
]);
const protein = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Protein.ZERO),
    schema_1.Schema.singleChoiceItem(Protein.ONE),
    schema_1.Schema.singleChoiceItem(Protein.TWO),
    schema_1.Schema.singleChoiceItem(Protein.THREE),
    schema_1.Schema.singleChoiceItem(Protein.FOUR)
]);
const blood = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Blood.ZERO),
    schema_1.Schema.singleChoiceItem(Blood.ONE),
    schema_1.Schema.singleChoiceItem(Blood.TWO),
    schema_1.Schema.singleChoiceItem(Blood.THREE),
    schema_1.Schema.singleChoiceItem(Blood.FOUR)
]);
const bilirubin = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Bilirubin.ZERO),
    schema_1.Schema.singleChoiceItem(Bilirubin.ONE),
    schema_1.Schema.singleChoiceItem(Bilirubin.TWO),
    schema_1.Schema.singleChoiceItem(Bilirubin.THREE),
    schema_1.Schema.singleChoiceItem(Bilirubin.FOUR)
]);
const urobilinogen = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Urobilinogen.ZERO),
    schema_1.Schema.singleChoiceItem(Urobilinogen.ONE),
    schema_1.Schema.singleChoiceItem(Urobilinogen.TWO),
    schema_1.Schema.singleChoiceItem(Urobilinogen.THREE),
    schema_1.Schema.singleChoiceItem(Urobilinogen.FOUR)
]);
const keton = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Keton.ZERO),
    schema_1.Schema.singleChoiceItem(Keton.ONE),
    schema_1.Schema.singleChoiceItem(Keton.TWO),
    schema_1.Schema.singleChoiceItem(Keton.THREE),
    schema_1.Schema.singleChoiceItem(Keton.FOUR)
]);
const rbc = schema_1.Schema.number().unit("/HPF").integer().min(0).max(9999);
const wbc = schema_1.Schema.number().unit("/HPF").integer().min(0).max(9999);
const sc = schema_1.Schema.number().unit("/HPF").integer().min(0).max(9999);
const bacteria = schema_1.Schema.number().unit("/HPF").integer().min(0).max(9999);
const fungus = schema_1.Schema.number().unit("/HPF").integer().min(0).max(9999);
const other = schema_1.Schema.string().optional().maxLength(10000);
exports.validator = schema_1.Schema.object()
    .expiration(31536000)
    .default({})
    .sealed(true)
    .properties({
    pH,
    gravity,
    glucose,
    protein,
    blood,
    bilirubin,
    urobilinogen,
    keton,
    RBC: rbc,
    WBC: wbc,
    SC: sc,
    bacteria,
    fungus,
    other
})
    .interpretation({ vocab: "ktx", code: "lab_total_urine_analysis" });
